// extracted by css-extract-rspack-plugin
export default {"cls1":"NewCitationPing-cls1_g5K","cls2":"NewCitationPing-cls2_HtL NewCitationPing-cls1_g5K"};